// Modules
import { createContext } from 'react'

// Context: Dispatch
const Dispatch = createContext()

// Export
export default Dispatch
